<template>
  <Wrapper classList="navigation-wrapper" :sticky="!isMobile" :style-list="wrapperStyle" @openEditor="openEditor" @stickyScroll="handleStickyScroll">
    <div class="navigation-container" :style="containerStyle">
      <div v-if="isMobile" class="navigation-mobile-container" v-clickoutside="closeMenu">
        <div class="bar">
          <div v-if="logo.show" class="navigation-logo">
            <img :src="logo.path" :style="logo.style" @click="onLogoClick">
          </div>
          <i class="el-icon-s-operation" :style="`color: ${btnColor};`" @click="openMenu"></i>
        </div>
        <div v-show="showMobileMenuWrapper" class="menu-item-wrapper">
          <transition name="toggle-cart" @after-leave="closeMenuWrapper">
            <div v-show="showMobileMenu" class="h5-menu-item">
              <div v-for="(item, index) in formattedMenus" class="item" :key="index" :class="`${index}` === selectedMenuIndex && 'is-active'" :index="`${index}`" @click="handleSelect(`${index}`)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-else class="navigation-container-content">
        <div v-if="logo.show" class="navigation-logo">
          <img :src="logo.path" :style="logo.style" @click="onLogoClick">
        </div>
        <el-menu
          class="navigation-container-menus"
          mode="horizontal"
          :default-active="selectedMenuIndex"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="(item, index) in formattedMenus"
            :key="index"
            :index="`${index}`"
            :disabled="isEditMode && item.isOnboardingPage"
            :title="isEditMode && item.isOnboardingPage && $t('microSite.editor.page.onboardingPage')"
          >
            <span>{{ item.label }}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import _ from 'lodash'
import Wrapper from '../../components/render/wrapper.vue'
import { mapGetters } from 'vuex'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { appendSourceCode } from '@/utils/common'
import RenderMixin from '../renderMixin'

export default {
  mixins: [RenderMixin],
  directives: {
    Clickoutside
  },
  components: {
    Wrapper
  },
  props: {
    menus: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: String,
      required: false
    },
    textColor: {
      type: String,
      required: false
    },
    activeColor: {
      type: String,
      required: false
    },
    hoverColor: {
      type: String,
      required: false
    },
    btnColor: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      selectedMenuIndex: null,
      fullWidth: false,
      showMobileMenu: false,
      showMobileMenuWrapper: false,
      logo: {
        show: false,
        path: '',
        style: null
      }
    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'isMobile', 'currentPage', 'pagePathPrefix']),
    formattedMenus () {
      const menus = []
      const onboardingMenus = []
      _.forEach(this.menus, (menu) => {
        if (menu.isOnboardingPage) {
          onboardingMenus.push(menu)
        } else {
          menus.push(menu)
        }
      })
      menus.push(...onboardingMenus)
      return menus
    },
    containerStyle () {
      return {
        '--menu-background-color': this.backgroundColor,
        '--menu-item-text-color': this.textColor,
        '--menu-item-active-color': this.activeColor,
        '--menu-item-hover-color': this.hoverColor,
        '--menu-size-height': this.height
        // '--menu-size-width': this.width
      }
    }
  },
  created () {
    this.resetSelectedMenu()
    this.$eventBus.$on('setSelectMenuItem', selectIndex => {
      this.selectedMenuIndex = `${selectIndex}`
    })
    this.$eventBus.$emit('getMicroSiteNavigationLogo', this.setLogoStatus)
  },
  methods: {
    setLogoStatus (logo) {
      this.logo = logo
    },
    resetSelectedMenu () {
      let path = this.$route.params.pagePath
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      const findIndex = _.findIndex(this.formattedMenus, { path: path })
      if (findIndex > -1) {
        this.selectedMenuIndex = `${findIndex}`
      }
    },
    handleSelect (index) {
      this.selectedMenuIndex = index
      const menu = this.formattedMenus[index]
      let path = this.pagePathPrefix + appendSourceCode(menu.path)
      const openWithNewWindow = menu.openInNewWindow
      const isInner = menu.isInner
      const menuPagePath = (menu.path || '').split('?')[0]
      if (menu.isOnboardingPage || menuPagePath === '/v/onboarding/questionnaire') {
        this.$eventBus.$emit('openOnboardingQuestionnairePage', openWithNewWindow)
        return
      }
      if (menu.isSatisfactionSurveyPage || _.includes([
        '/v/satisfaction-survey/questionnaire',
        '/v/candidate-portal/questionnaire'
      ], menuPagePath)) {
        this.$eventBus.$emit('openQuestionnaireQuestionnairePage', openWithNewWindow)
        return
      }
      if (openWithNewWindow) {
        if (isInner) {
          window.open(path, '_blank')
        } else {
          window.open(menu.path, '_blank')
        }
      } else {
        if (isInner) {
          delete this.$route.query.scrollin
          if (!path.includes('scrollin')) {
            path += path.includes('?') ? '&scrollin=0' : '?scrollin=0'
          }
          this.$router.push({
            path: path,
            query: this.$route.query
          })
        } else {
          window.location.href = menu.path
        }
      }
      this.closeMenu()
    },
    handleStickyScroll (params, stickyRef, wrapperRef) {
      // to-do active menu
      if (!wrapperRef) {
        return
      }
      const rootDiv = wrapperRef.parentElement
      _.forEach(rootDiv.children, child => {
        const rect = child.getBoundingClientRect()
        if (rect.y < 70) {
          // to-do get renderData id and active menu item
        }
      })
    },
    openEditor () {
      this.$emit('openEditor')
    },
    openMenu () {
      if (this.showMobileMenu) {
        this.showMobileMenu = false
      } else {
        this.showMobileMenuWrapper = true
        this.$nextTick(() => {
          this.showMobileMenu = true
        })
      }
    },
    closeMenu () {
      this.showMobileMenu = false
    },
    closeMenuWrapper () {
      this.showMobileMenuWrapper = false
    },
    onLogoClick () {
      this.$eventBus.$emit('microSiteNavigationLogoClick')
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.navigation-mobile-container {
  position: relative;

  .bar {
    position: inherit;
    width: 100%;
    height: var(--menu-size-height, 60px);
    box-sizing: border-box;
    border-bottom: solid 1px #e6e6e6;
    background: var(--menu-background-color, #fff);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    z-index: 99;

    .navigation-logo {
      display: flex;
      height: 100%;
      position: absolute;
      left: 10px;
      align-items: center;

      img {
        cursor: pointer;
        width: 50px;
        height: 50px;
      }
    }
  }

  i {
    font-size: 22px;
  }
  .menu-item-wrapper {
    overflow: hidden;
    position: absolute;
    z-index: 20;
    right: 0px;
    top: 60px;
  }
  .h5-menu-item {
    min-width: 120px;
    background: var(--menu-background-color, #fff);
    color: var(--menu-item-text-color, #333);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    cursor: pointer;

    .item {
      padding: 10px;
      text-align: center;
      border-bottom: 1px solid #aaaaaa;

      &:last-child {
        border-bottom: none;
      }

      &.is-active {
        background: var(--menu-item-active-color);
      }
    }
  }
}
.flex_box {
  display: flex;
  align-items: center;
}
.toggle-cart-enter-active,
.toggle-cart-leave-active {
  transition: all 0.4s ease-out;
}
.toggle-cart-enter,
.toggle-cart-leave-active {
  transform: translateY(-100%);
}
.navigation-container {
  width: var(--menu-size-width);
  background-color: var(--menu-background-color, #fff);
  &>div {
    width: 100%;
  }
  &-content {
    display: flex;
    .navigation-logo {
      display: flex;
      align-items: center;
      padding: 5px 0 0 10px;
      border-bottom: 1px solid #e6e6e6;
      img {
        width: 50px;
        height: 50px;
        cursor: pointer;
      }
      & + .navigation-container-menus {
        margin-left: 83px;
      }
    }
  }
  .navigation-container-menus {
    flex: 1;
    display: flex;
    padding-right: 50px;
    background-color: var(--menu-background-color, #fff);
    border-bottom: 0;
    .el-menu-item {
      height: var(--menu-size-height, 60px);
      line-height: var(--menu-size-height, 60px);
      color: var(--menu-item-text-color, #909399);
      background-color: var(--menu-background-color, #fff);

      &:hover {
        color: var(--menu-item-text-color, #303133);
        background-color: rgba(0, 0, 0, 0.05);
      }
      &:focus {
        color: var(--menu-item-text-color, #303133);
        background-color: var(--menu-background-color, rgba(0, 0, 0, 0.05));
      }
      &.is-active {
        color: var(--menu-item-text-color, #303133);
        border-bottom-color: var(--menu-item-active-color, #0096cc);
      }
      &.is-disabled {
        opacity: 1;
        cursor: default;
      }
    }
  }
  .edit-btn {
    margin-top: 10px;
    margin-right: 20px;

    .el-button {
      width: 95px;
      padding: 8px 20px;
      height: 32px;
      color: #fff;
      background-color: #3f3f3f;
    }
  }
}

.microsite-page .navigation-container .van-sticky {
  display: block;
  width: 100%;
}
.navigation-container .van-sticky--fixed {
  right: inherit;
  left: inherit;
}
</style>
